// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__13g6Z","footer":"ChangeClinic_footer__urNl9"};